import { render, staticRenderFns } from "./DashboardArticleModal.vue?vue&type=template&id=56b79c9a"
import script from "./DashboardArticleModal.vue?vue&type=script&lang=js"
export * from "./DashboardArticleModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports